<template>
  <data-form
    :data="data"
    :formFields="formFields"
    @save="saveData"
    @cancel="cancel"
  />
</template>

<script>
import DataForm from "../widgets/DataForm.vue";
import VehicleTypeDataService from "../../services/vehicle-type.service";

export default {
  name: "vehicle-type-form",
  props: ["data"],
  components: {
    DataForm,
  },
  data() {
    return { message: "" };
  },
  computed: {
    formFields() {
      return {
        id: { type: "hidden" },
        name: { label: "Naziv", type: "text" },
      };
    },
  },
  methods: {
    saveData(newData) {
      if (newData && newData.id) {
        this.updateVehicleType(newData);
      } else {
        this.createVehicleType(newData);
      }
    },
    cancel() {
      this.$store.commit("app/hideModal");
    },
    updateVehicleType(newData) {
      VehicleTypeDataService.update(newData.id, newData)
        .then(() => {
          this.$store.commit("app/showAlert", {
            type: "success",
            message: "Tip vozila je promenjen!",
          });
          this.$store.commit("app/hideModal");
        })
        .catch((e) => {
          this.$store.commit("app/showAlert", {
            type: "danger",
            message: e,
          });
        });
    },
    createVehicleType(newData) {
      VehicleTypeDataService.create(newData)
        .then(() => {
          this.$store.commit("app/showAlert", {
            type: "success",
            message: "Tip vozila je kreiran!",
          });
          this.$store.commit("app/hideModal");
        })
        .catch((e) => {
          this.$store.commit("app/showAlert", {
            type: "danger",
            message: e,
          });
        });
    },
  },
};
</script>
